import { useState } from "react";
import { removeNotification as removeNotificationAction } from "src/redux/reducers";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { translate } from "src/services";
import {
  NotificationList as NotificationListContainer,
  Notification as NotificationContainer,
  NotificationClose,
  NotificationCloseIcon,
  Button,
} from "./../styled";
import Modal from "./Modal";

interface NotificationProps {
  id: string;
  message: string;
  color: string;
  removeNotificationHandler: (id: string) => void;
  autoClose: boolean;
  seeMoreContent?: () => JSX.Element;
  onSeeMoreContent: (seeMoreContent: JSX.Element) => void;
}

const Notification = ({
  id,
  message,
  color,
  removeNotificationHandler,
  seeMoreContent,
  onSeeMoreContent,
}: NotificationProps) => {
  return (
    <NotificationContainer color={color}>
      <NotificationClose onClick={() => removeNotificationHandler(id)}>
        <NotificationCloseIcon />
      </NotificationClose>
      <div>{message}</div>
      {seeMoreContent && (
        <Button
          color="primary"
          text
          onClick={() => onSeeMoreContent(seeMoreContent())}
        >
          {translate("common.seeMore")}...
        </Button>
      )}
    </NotificationContainer>
  );
};

const NotificationList = () => {
  const [currentSeeMoreContent, setCurrentSeeMoreContent] = useState<
    JSX.Element | undefined
  >();

  const notifications = useAppSelector((state) => state.notifications);
  const dispatch = useAppDispatch();

  return (
    <NotificationListContainer>
      {notifications.map(
        ({ id, message, color, autoClose, seeMoreContent }) => (
          <Notification
            id={id}
            key={id}
            message={message}
            color={color}
            autoClose={autoClose}
            removeNotificationHandler={(id) =>
              dispatch(removeNotificationAction(id))
            }
            seeMoreContent={seeMoreContent}
            onSeeMoreContent={(smc) => setCurrentSeeMoreContent(smc)}
          />
        )
      )}
      {currentSeeMoreContent && (
        <Modal onClose={() => setCurrentSeeMoreContent(undefined)}>
          {currentSeeMoreContent}
        </Modal>
      )}
    </NotificationListContainer>
  );
};

export default NotificationList;
